import React, { Component } from 'react';

import ReactTable from 'react-table';

import 'react-table/react-table.css';

import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import OptionsDropdown from 'components/shared/OptionsDropdown';
import SurveyStatus from './SurveyStatus';

import { numberOfRows } from 'helpers/ReactTableSize';
import { isFilterInStrings } from 'helpers/StringHelper.js';
import { toFriendlyDateString } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';

import { getTranslatedString } from 'helpers/i18n';

class SurveysTable extends Component {
  constructor(props) {
    super(props);
    const tableSize = numberOfRows(this.props.surveys);
    this.state = {
      tableSize,
      typeFilter: '',
    };
  }

  getTypeFilterType = e => {
    this.setState({ typeFilter: e.target.value });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(
      {
        tableSize: numberOfRows(nextProps.surveys),
      },
      function() {
        this.forceUpdate();
      }
    );
  }

  render() {
    const data = this.props.surveys || [];

    let filteredData = [];
    if (data && data.length > 0) {
      filteredData = data.filter(item =>
        isFilterInStrings(
          [
            item.property,
            item.title,
            item.start_date,
            item.expiration_date,
            item.responses,
            item.status,
          ],
          this.state.typeFilter
        )
      );
    }

    const tbdText = getTranslatedString('landlordPortal.surveys.tbd');
    const columns = [
      {
        header: getTranslatedString('landlordPortal.surveys.name'),
        headerClassName: 'headerColumn',
        accessor: 'title',
      },
      {
        header: getTranslatedString('landlordPortal.surveys.startDate'),
        headerClassName: 'headerColumn',
        accessor: 'start_date',
        render: row => (row.value ? toFriendlyDateString(row.value) : tbdText),
      },
      {
        header: getTranslatedString('landlordPortal.surveys.expirationDate'),
        headerClassName: 'headerColumn',
        accessor: 'expiration_date',
        render: row => (row.value ? toFriendlyDateString(row.value) : tbdText),
      },
      {
        header: getTranslatedString('landlordPortal.surveys.responses'),
        headerClassName: 'headerColumn',
        accessor: 'responses_count',
      },
      {
        header: getTranslatedString('landlordPortal.surveys.status'),
        headerClassName: 'headerColumn',
        accessor: 'status',
        render: row => <SurveyStatus status={row.value} />,
      },
      {
        header: getTranslatedString('landlordPortal.surveys.action'),
        headerClassName: 'headerColumn',
        accessor: 'id',
        render: row => (
          <OptionsDropdown allowedOpen={!this.props.optionsDropdown}>
            {row.row.status !== 'editing' && (
              <span>
                <MenuItem
                  primaryText={getTranslatedString('landlordPortal.surveys.details')}
                  style={{ fontSize: '14px' }}
                  onClick={() => this.props.toggleSurveyResultsDialog(row.row)}
                />
              </span>
            )}
            {row.row.status === 'editing' && (
              <span>
                <MenuItem
                  primaryText={getTranslatedString('landlordPortal.surveys.edit')}
                  style={{ fontSize: '14px' }}
                  onClick={() => this.props.toggleSurveyDetailsDialog(row.row)}
                />
              </span>
            )}
            <MenuItem
              primaryText={getTranslatedString('landlordPortal.surveys.delete')}
              style={{ fontSize: '14px' }}
              onClick={() => this.props.deleteSurvey(row.row.id)}
            />
          </OptionsDropdown>
        ),
      },
    ];

    return (
      <div>
        <div className="stage-header clearfix" style={{ marginBottom: '25px' }}>
          <FlatButton
            label={getTranslatedString('landlordPortal.surveys.addSurvey')}
            type="submit"
            primary={true}
            backgroundColor={AccentColor()}
            hoverColor="grey"
            onClick={this.props.toggleSurveyDialog}
            style={{
              color: 'white',
              float: 'right',
              height: '30px',
              fontSize: '13px',
              lineHeight: '30px',
              marginTop: '3px',
            }}
          />
          <span className="page-title">{getTranslatedString('landlordPortal.surveys.header')}</span>
        </div>
        <div className="dashboard-container" ref="LeadsContainer" style={{ marginBottom: '70px' }}>
          <div className="row" style={{ marginTop: '-20px' }}>
            <TextField
              hintText={getTranslatedString('landlordPortal.surveys.filter')}
              style={{ fontSize: '13px' }}
              value={this.state.typeFilter}
              onChange={this.getTypeFilterType}
            />
          </div>
          <ReactTable
            collapseOnSortingChange={false}
            collapseOnPageChange={false}
            collapseOnDataChange={false}
            data={filteredData}
            columns={columns}
            pageSize={this.state.tableSize}
            noDataText={getTranslatedString('landlordPortal.surveys.noSurveys')}
            showPagination={false}
            showPageSizeOptions={false}
          />
        </div>
      </div>
    );
  }
}

export default SurveysTable;
